export default __webpack_public_path__ + "static/media/drakkar-header.60a2b0dd.png";